@if (showPen && !lukittu) {
  <app-icon-button (click)="toggleEdit()" actionId="Avasi dialogin: Veroilmoitus > Avaa muokkaa kynä" [dynamicClass]="{ 'edit-pen-active': editing }" additionalClass="edit-pen">
    <span class="fa fa-pencil"></span>
  </app-icon-button>
}

@if (editing && !lukittu) {
  <div class="tili-num">{{ numero }}</div>
  <div class="date-range long-col">{{ label }}</div>
  <div class="date-range short-col">
    {{ formattedValue }}
    <mat-date-range-input [rangePicker]="picker" style="width: 1px; height: 1px; color: transparent; background-color: transparent; overflow: hidden; max-width: 1px; max-height: 1px; float: right">
      <input matStartDate placeholder="Alkoi" [formField]="vali.alku" (blur)="tallennaMuuttunutArvo()" style="width: 80px; text-align: center; background-color: white" />
      <input matEndDate placeholder="Loppui" [formField]="vali.loppu" (blur)="tallennaMuuttunutArvo()" style="width: 80px; text-align: center; background-color: white" />
    </mat-date-range-input>
  </div>
  <div class="date-range end-marking">
    <mat-datepicker-toggle style="position: absolute; top: -2px; left: 2px" [for]="picker"></mat-datepicker-toggle>
    <mat-date-range-picker (closed)="tallennaMuuttunutArvo()" #picker></mat-date-range-picker>
    @if (saving) {
      <span class="saving" [@slowInQuickOut]="'in'">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </span>
    }
    @if (saveSuccess) {
      <span class="save-success-text" [@quickInSlowOut]="'in'"> Päivämääräväli tallennettiin </span>
    }
    @if (saveSuccess) {
      <mat-icon class="save-success-icon" [@quickInSlowOut]="'in'" [ngStyle]="{ color: '#4bd76b', 'vertical-align': 'middle', 'margin-bottom': '6px' }">done</mat-icon>
    }
    @if (saveFailure) {
      <span class="save-failure-text"> Tallentamisen aikana tapahtui virhe. Ole hyvä ja yritä uudelleen. </span>
    }
    @if (saveFailure) {
      <mat-icon class="save-failure-icon" [ngStyle]="{ color: 'rgb(255, 72, 102)', 'vertical-align': 'middle' }">error_outline</mat-icon>
    }
  </div>
  <!-- <div *ngIf="naytaEhdotus" style="flex-basis: 100%;" class="ehdotusnappula-container">
  <button class="primarybutton" (click)="ehdotus()" mat-button>Hae ehdotus</button>
</div> -->
  @if (kenttaVirhe) {
    <div class="kentta-virhe-container">
      @for (virheViesti of kentanVirheViestit; track virheViesti) {
        <div class="kentta-virhe-rivi">
          <mat-icon class="kentta-virhe-ikoni">error_outline</mat-icon>
          <span>{{ virheViesti }}</span>
        </div>
      }
    </div>
  }
} @else {
  <div class="tili-num">{{ numero }}</div>
  <div class="long-col">{{ label }}</div>
  <div class="short-col-ext">{{ formattedValue }}</div>
  <!-- <div class="end-marking"></div> -->
}
